module.exports = __webpack_public_path__ + "img/iphone-slide6.32df6631.jpg";